import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { getCalendarEntryByFolderId } from 'owa-calendar-cache';

/**
 * Returns true if the meeting on a calendar which tallies attendee responses
 * @param event calendar event object
 */
export default function isOnCalendarTallyingResponses(event: CalendarEvent): boolean {
    if (event) {
        const calendarEntry = getCalendarEntryByFolderId(event.ParentFolderId.Id);
        return !!calendarEntry?.IsTallyingResponses;
    }

    return false;
}
